import {
  Box,
  Button,
  Typography,
  Modal,
  TextField,
  MenuItem,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Radio,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import { useTheme } from "@emotion/react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

const AddTaxFormView = ({
  handleFormChange,
  handleDate,
  formObject,
  open,
  handleOpen,
  handleClose,
  handleSaveTaxForm,
  handleFileUpload,
  loading,
}) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen={false}
      fullWidth={true}
    >
      <DialogTitle>Upload Tax Form</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <Button
            variant="contained"
            component="label"
            onChange={handleFormChange("fileBlob")}
          >
            <UploadIcon sx={{ mr: "1rem" }} />
            Upload Tax Form
            <input hidden accept="image/*,.pdf" type="file" />
          </Button>
          {formObject.fileBlob && (
            <Typography>{formObject.fileBlob.name}</Typography>
          )}
          {/* <FormGroup
              sx={{
                marginLeft: "1rem",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
              }}
            >
              <FormControlLabel
                control={
                  <Radio
                    checked={formObject.type === "PER-PROJECT"}
                    onChange={handleFormChange("type")}
                    name="PER-PROJECT"
                  />
                }
                label={"Per Project"}
              />
              <FormControlLabel
                control={
                  <Radio
                    checked={formObject.type === "ANNUAL"}
                    onChange={handleFormChange("type")}
                    name="ANNUAL"
                  />
                }
                label={"Annual"}
              />
            </FormGroup> */}
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              disabled={loading}
              label="Expiration Date"
              value={formObject.expirationDate}
              onChange={(newValue) => {
                handleDate(newValue);
              }}
              renderInput={(params) => (
                <TextField fullWidth sx={{}} {...params} />
              )}
            />
          </LocalizationProvider>

          <TextField label="Form Name" onChange={handleFormChange("name")} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={() => {
            const { fileBlob, name, type } = formObject;
            if (!name || !type || !fileBlob) return;
            handleSaveTaxForm(fileBlob, name, type);
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default AddTaxFormView;
